import { useSwipeEvents } from '@kuik/modules/swipe-events.js';

function initLightboxGalleryDialogEvents(dialog) {
    dialog.addEventListener('toggle', () => {
        if (dialog.open) {
            for (const frame of Array.from(dialog.querySelectorAll('iframe'))) {
                if (frame.dataset.lazyLoadSrc) {
                    frame.src = frame.dataset.lazyLoadSrc;
                }
            }
        } else {
            for (const player of Array.from(dialog.querySelectorAll('video, audio'))) {
                player.pause();
            }
            for (const frame of Array.from(dialog.querySelectorAll('iframe'))) {
                frame.dataset.lazyLoadSrc = frame.src;
                frame.src = 'about:blank';
            }
        }
    });
}

function initLightboxGalleryDialogKeyboardEvents(dialog) {
    const back = dialog.querySelector('[data-lightbox-back]');
    const previous = dialog.querySelector('[data-lightbox-previous]');
    const next = dialog.querySelector('[data-lightbox-next]');

    useSwipeEvents(dialog);

    dialog.addEventListener('swipe-left', () => {
        next?.click();
    });
    dialog.addEventListener('swipe-right', () => {
        previous?.click();
    });

    dialog.addEventListener('keyup', (e) => {
        switch (e.key) {
            case 'Backspace': {
                back?.click();
                break;
            }
            case 'ArrowLeft': {
                previous?.click();
                break;
            }
            case 'ArrowRight': {
                next?.click();
                break;
            }
        }
    });
}

function initLightboxGalleryDialog(dialog) {
    initLightboxGalleryDialogEvents(dialog);
    initLightboxGalleryDialogKeyboardEvents(dialog);
}

function initLightboxGallery(element) {
    const dialogs = element.querySelectorAll("dialog");
    for (const dialog of dialogs) {
        initLightboxGalleryDialog(dialog);
    }
    element.classList.remove('js-lightbox-gallery');
}

const lightboxGalleries = document.querySelectorAll('.js-lightbox-gallery');
for (const element of lightboxGalleries) {
    initLightboxGallery(element);
}